module.exports = __webpack_public_path__ + "img/announcement-03.68ea4757.svg";